import {Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {ImageUtilService} from "./image_util.service";

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(
    private translate: TranslateService,
    private imageUtilService: ImageUtilService
  ) {
  
  }
  
  setAvatarUrl(url) {
    if (!url) {
      return '/avatar/default_avatar.png';
    }
    
    if (url.indexOf('http') === 0) {
      return url;
    } else {
      return '/avatar/' + url;
    }
  }
  
  setMerchantAvatarUrl(url) {
    if (!url) {
      return '/avatar/default_avatar.png';
    }
    
    if (url.indexOf('http') === 0) {
      return url;
    } else {
      return '/merchant_avatar/' + url;
    }
  }
  
  getDateTimeStr2(dd) {
    let y = dd.getFullYear();
    let m = dd.getMonth() + 1;//获取当前月份的日期
    let d = dd.getDate();
    
    let mStr = m.toString();
    let dStr = d.toString();
    
    return y + '-' + mStr + '-' + dStr;
  }
  
  getDateTimeStr3(dd) {
    let h: any = dd.getHours();
    let minute: any = dd.getMinutes();
    let s: any = dd.getSeconds();
    
    if (h >= 0 && h <= 9) {
      h = '0' + h;
    }
    if (minute >= 0 && minute <= 9) {
      minute = '0' + minute;
    }
    if (s >= 0 && s <= 9) {
      s = '0' + s;
    }
    
    
    return h + ':' + minute + ':' + s;
  }
  
  getDateTimeStr4(timeText) {
    let date = new Date(timeText);
    
    return this.getDateTimeStr2(date);
  }
  
  getLocalDateTimeStr(timeText) {
    let date = new Date(timeText);
    let time = date.getTime();
    
    let offsetMinutes = new Date().getTimezoneOffset();
    time += (offsetMinutes * -1) * 60 * 1000;
    
    let newDate = new Date(time);
    
    return this.getDateTimeStr2(newDate) + ' ' + this.getDateTimeStr3(newDate);
  }
  
  setProductImageUrl(url) {
    if (!url) {
      return '/product_image/default_product.png';
    }
    
    if (url.indexOf('http') === 0) {
      return url;
    } else {
      return '/product_image/' + url;
    }
  }
  
  convertToFile(product) {
    if (product.imageType === 'upload' || product.imageType === 'clipboard') {
      return product.file;
    }
    
    return this.imageUtilService.dataURLtoFile(product.imageUrl, '1.png');
  }
  
  toLocalIsoNoZone(date = new Date()) {
    const pad = n => String(n).padStart(2, '0');
    
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
      + `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }
}
